var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLockClosed = function SvgLockClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.564 2.47h2.872l.723.792v2.18h1.112l1.295 1.427v4.739l-1.295 1.427H4.729l-1.295-1.427V6.87L4.73 5.443h1.112V3.262l.723-.792Zm5.002 4.785v3.967l-.738.813H5.172l-.738-.813V7.256l.738-.813h5.656l.738.812ZM6.84 5.443H9.16V3.65l-.165-.18H7.005l-.164.18v1.793Zm.722 2.493v2.709h1V7.936h-1Z",
    fill: "currentColor"
  })));
};
export default SvgLockClosed;